import React, { useContext, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { GetData, apiheader } from '../../utils/fetchData'; 
import { Toast } from 'primereact/toast';
import { VendersContext } from '../../context/Store';
import OurAbout from './OurAbout';
import OurBlogs from './OurBlogs';
import OurClients from './OurClients';
import OurFooter from './OurFooter';
import OurProjects from './OurProjects';
import OurServices from './OurServices';

const Settings = () => {
    let { isLang } = useContext(VendersContext);

    let { section } = useParams();
    const [data, setData] = useState('')
    const [isLaoding, setIsLaoding] = useState(false);
    const toast = useRef(null);


    const fetchDataSections = async () => {
        const url = `${process.env.REACT_APP_API_URL}/settings/get-data?section=${section}`;
        let data = await GetData(url, apiheader);
        setData(data?.data);
        if (data?.status === 200) {
            setTimeout(() => {
                setIsLaoding(true)
            }, 200);
        }
    }
    useEffect(() => {
        fetchDataSections();
    }, [section])

    return (
        <>
            <Toast ref={toast} position={isLang === "en" ? 'top-right' : 'top-left'} />

            {
                section === 'about_us' &&
                <>
                    <OurAbout toast={toast} isLaoding={isLaoding} data={data} section={section} setIsLaoding={setIsLaoding} />
                </>
            }
            {
                section === 'our_clients' &&
                <>
                    <OurClients toast={toast} isLaoding={isLaoding} data={data} section={section} setIsLaoding={setIsLaoding} />
                </>
            }
            {
                section === 'our_projects' &&
                <>
                    <OurProjects toast={toast} isLaoding={isLaoding} data={data} section={section} setIsLaoding={setIsLaoding} />
                </>
            }

            {
                section === 'our_services' &&
                <>
                    <OurServices toast={toast} isLaoding={isLaoding} data={data} section={section} setIsLaoding={setIsLaoding} />
                </>
            }

            {
                section === 'blogs' &&
                <>
                    <OurBlogs toast={toast} isLaoding={isLaoding} data={data} section={section} setIsLaoding={setIsLaoding} />
                </>
            }

            {
                section === 'footer' &&
                <>
                    <OurFooter toast={toast} isLaoding={isLaoding} data={data} section={section} setIsLaoding={setIsLaoding} />
                </>
            }
        </>
    )
}

export default Settings
